import { Button } from 'antd'
import { useNavigate } from 'react-router-dom'
import '../style/notFound.css'
const NotFound = () => {
  const navigate = useNavigate()
  return (
    <div className='background'>
      <div className='container'>
        <div className='left-section'>
          <div className='inner-content'>
            <h1 className='heading'>404</h1>
            <p className='subheading'>ページを見つかりませんでした</p>
            <div className='flex justify-center mt-6'>
              <Button
                className='bg-white text-black'
                size='large'
                onClick={() => navigate('/')}
              >
                ホームに戻る
              </Button>
            </div>
          </div>
        </div>
        <div className='right-section flex justify-center items-center'>
          <img src='/hero.png' className='sm:h-[30rem] h-[20rem]' />
        </div>
      </div>
    </div>
  )
}

export default NotFound
